import * as React from 'react';
import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ReactComponent as CloseIcon } from '../../assets/svg/close-circle.svg';
import './style.scss';

export default function ScrollDialog(props) {
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (props.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.open]);

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.onClosed}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        className="desModal">
        <DialogTitle id="scroll-dialog-title" className="titleHeader">
          {props.title}
          <span className="closeIcon" onClick={props.onClosed}>
            <CloseIcon />
          </span>
        </DialogTitle>
        <DialogContent dividers="paper">
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            className="dialogContent">
            {props.content}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialogBut">
          <Button sx={{ width: '120px' }} variant="contained" className="textTransform" onClick={props.onClosed}>
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
